import Chelia6Attic1 from './Chelia 6 3 Lantai (1).webp'
import Chelia6Attic2 from './Chelia 6 3 Lantai (2).webp'



const Chelia6Atticimages =[
Chelia6Attic1,Chelia6Attic2
]

export default Chelia6Atticimages;